module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-collage-d0bd7441b245fa801f0568bc52bcfa72.jpg";